import { notificationManager } from '../Stores/NotificationManager'
import { restClient } from '@/Core'

export const ChangeAllNotificationsIsReadedTask = async () => {
    try {
        await restClient.post('/services/user/notifications/all/change_is_readed')

        // Optimistically reflect the server state locally. We intentionally do
        // NOT reload the list here: callers (page tabs / drawer tabs) own their
        // own type/isReaded filter, and reloading without it would replace the
        // list with the wrong filter. The previous version also set
        // isNotificationLoading=true, which made LoadNotificationListTask
        // early-return — so the list never refreshed and items stayed unread.
        notificationManager.markAllAsRead()
        notificationManager.clearUnreadCount()
    } catch (error) {
        console.warn('ChangeAllNotificationsIsReadedTask error:', error)
    }
}
